export const ID = '50E0XFASR6'
export const KEY = 'e2eb48e64bf36a99be028ba210a79052'

export const KEYWRITE = 'b802dbdc88c8f2a7015cc73ce0d1234b'